import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function VoucherUseIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="63"
      height="65"
      viewBox="0 0 63 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.4929 37.0349C60.7145 52.5291 49.7058 65 32.616 65C17.3219 65 1.31641 55.1928 1.31641 37.0349C1.31641 3.40116 18.7272 0 35.8171 0C52.9069 0 62.4929 18.8769 62.4929 37.0349Z"
        fill="#E3F1FF"
      />
      <rect
        x="17.5508"
        y="11.3418"
        width="26.5824"
        height="41.9721"
        rx="3.27522"
        fill="#F6F6F6"
      />
      <path
        d="M41.3334 31.9773C41.3334 37.5792 36.7921 42.1205 31.1901 42.1205C25.5882 42.1205 21.0469 37.5792 21.0469 31.9773C21.0469 26.3753 25.5882 21.834 31.1901 21.834C36.7921 21.834 41.3334 26.3753 41.3334 31.9773Z"
        fill="#E1E8F6"
      />
      <g clipPath="url(#clip0_9168_20846)">
        <path
          d="M36.0841 27.0801H26.2906C25.6145 27.0801 25.0664 27.6282 25.0664 28.3043V35.6494C25.0664 36.3255 25.6145 36.8736 26.2906 36.8736H36.0841C36.7602 36.8736 37.3083 36.3255 37.3083 35.6494V28.3043C37.3083 27.6282 36.7602 27.0801 36.0841 27.0801Z"
          stroke="#F6F6F6"
          strokeWidth="1.43291"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.3083 28.916L31.8178 32.405C31.6288 32.5233 31.4103 32.5861 31.1873 32.5861C30.9643 32.5861 30.7459 32.5233 30.5569 32.405L25.0664 28.916"
          stroke="#F6F6F6"
          strokeWidth="1.43291"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M25.9275 32.6125C25.8466 33.3174 25.3458 33.8847 24.5684 33.8847C23.8726 33.8847 23.1445 33.4385 23.1445 32.6125C23.1445 31.0825 23.9366 30.9277 24.714 30.9277C25.4915 30.9277 25.9275 31.7865 25.9275 32.6125Z"
        fill="#D680E0"
      />
      <path
        d="M30.365 32.6125C30.2841 33.3174 29.7833 33.8847 29.0059 33.8847C28.3101 33.8847 27.582 33.4385 27.582 32.6125C27.582 31.0825 28.3741 30.9277 29.1515 30.9277C29.929 30.9277 30.365 31.7865 30.365 32.6125Z"
        fill="#D680E0"
      />
      <path
        d="M34.7986 32.6125C34.7177 33.3174 34.2169 33.8847 33.4395 33.8847C32.7437 33.8847 32.0156 33.4385 32.0156 32.6125C32.0156 31.0825 32.8077 30.9277 33.5851 30.9277C34.3626 30.9277 34.7986 31.7865 34.7986 32.6125Z"
        fill="#D680E0"
      />
      <path
        d="M39.2361 32.6125C39.1552 33.3174 38.6544 33.8847 37.877 33.8847C37.1812 33.8847 36.4531 33.4385 36.4531 32.6125C36.4531 31.0825 37.2452 30.9277 38.0226 30.9277C38.8001 30.9277 39.2361 31.7865 39.2361 32.6125Z"
        fill="#D680E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4844 11.0625H41.3538C43.1142 11.0625 44.5413 12.4896 44.5413 14.25V50.914C44.5413 52.6744 43.1142 54.1015 41.3538 54.1015H20.4844C18.724 54.1015 17.2969 52.6744 17.2969 50.914V14.25C17.2969 12.4896 18.724 11.0625 20.4844 11.0625ZM20.4844 12.975C19.7802 12.975 19.2094 13.5458 19.2094 14.25V50.914C19.2094 51.6181 19.7802 52.189 20.4844 52.189H41.3538C42.058 52.189 42.6288 51.6181 42.6288 50.914V14.25C42.6288 13.5458 42.058 12.975 41.3538 12.975H20.4844Z"
        fill="#4E7FFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4451 48.2426H18.6641V46.3301H43.4451V48.2426Z"
        fill="#4E7FFF"
      />
      <circle cx="30.8733" cy="50.2825" r="1.3616" fill="#A3B7E4" />
      <path
        d="M18.6641 16.2432H43.4451"
        stroke="#4E7FFF"
        strokeWidth="1.91249"
      />
      <mask
        id="path-14-outside-1_9168_20846"
        maskUnits="userSpaceOnUse"
        x="32"
        y="7"
        width="20"
        height="20"
        fill="black"
      >
        <rect fill="white" x="32" y="7" width="20" height="20" />
        <path d="M49.8026 18.0038C49.3432 21.7707 46.4995 24.8026 42.085 24.8026C38.1344 24.8026 34 22.4183 34 18.0038C34 9.82688 38.4974 9 42.9119 9C47.3264 9 49.8026 13.5893 49.8026 18.0038Z" />
      </mask>
      <path
        d="M49.8026 18.0038C49.3432 21.7707 46.4995 24.8026 42.085 24.8026C38.1344 24.8026 34 22.4183 34 18.0038C34 9.82688 38.4974 9 42.9119 9C47.3264 9 49.8026 13.5893 49.8026 18.0038Z"
        fill="#FFBE40"
      />
      <path
        d="M49.8026 18.0038L51.4281 18.202L51.4402 18.1033V18.0038H49.8026ZM34 18.0038H35.6376H34ZM48.177 17.8056C47.8089 20.8238 45.6003 23.165 42.085 23.165V26.4402C47.3988 26.4402 50.8775 22.7176 51.4281 18.202L48.177 17.8056ZM42.085 23.165C40.4135 23.165 38.7503 22.6554 37.5449 21.7495C36.3772 20.872 35.6376 19.6346 35.6376 18.0038H32.3624C32.3624 20.7875 33.69 22.9495 35.5772 24.3678C37.4266 25.7576 39.8059 26.4402 42.085 26.4402V23.165ZM35.6376 18.0038C35.6376 14.2009 36.6731 12.5595 37.7688 11.7563C38.9808 10.8677 40.7216 10.6376 42.9119 10.6376V7.36239C40.6878 7.36239 37.9725 7.54577 35.8323 9.11485C33.5756 10.7693 32.3624 13.6298 32.3624 18.0038H35.6376ZM42.9119 10.6376C44.4725 10.6376 45.7321 11.423 46.6642 12.7757C47.6184 14.1604 48.165 16.0747 48.165 18.0038H51.4402C51.4402 15.5184 50.7486 12.9308 49.3611 10.9173C47.9516 8.87169 45.7659 7.36239 42.9119 7.36239V10.6376Z"
        fill="white"
        mask="url(#path-14-outside-1_9168_20846)"
      />
      <path
        d="M43.8709 17.6235L42 17V13.75M46.875 17C46.875 19.6924 44.6924 21.875 42 21.875C39.3076 21.875 37.125 19.6924 37.125 17C37.125 14.3076 39.3076 12.125 42 12.125C44.6924 12.125 46.875 14.3076 46.875 17Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_9168_20846">
          <rect
            width="14.6903"
            height="14.6903"
            fill="white"
            transform="translate(23.8438 24.6318)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
